'use client';
import styles from '../../page.module.scss';
import menu from '../../assets/icons/menu.svg';
import libro from '../../assets/icons/libro-la-libre.png';
import equis from '../../assets/icons/equis.jpg';
import { useState } from 'react';
import Link from 'next/link';
import SocialIcons from './SocialIcons';

export default function Navbar() {
  const [closeNavBar, setCloseNavBar] = useState(true);

  return (
    <div className={styles.mainBar}>
      <nav className={styles.nav}>
        <img
          className={styles.navMenuIcon}
          onClick={() => setCloseNavBar(!closeNavBar)}
          src={closeNavBar ? menu.src : equis.src}
          alt=""
        />
        <p className={styles.name}>
          <strong> La libre editora</strong>
        </p>
        <Link href="/">
          {' '}
          <img
            className={styles.mainLogo}
            style={{ width: '40px' }}
            src={libro.src}
            alt="Logo de La Libre"
          />
        </Link>
      </nav>
      <div className={styles.navSocialIconsContainer}>
        <SocialIcons />
      </div>
      <div className={`${styles.movePanel} ${closeNavBar && styles.closed}`}>
        <div className={styles.navItemsContainer}>
          <ul className={styles.navList}>
            <li>
              {' '}
              <Link onClick={() => setCloseNavBar(true)} href={'/#catalogo'}>
                Catálogo
              </Link>
            </li>
            <li>
              <Link onClick={() => setCloseNavBar(true)} href={'/#leenos'}>
                Prensa
              </Link>
            </li>
            <li>
              <Link onClick={() => setCloseNavBar(true)} href={'/#autores'}>
                Nuestrxs Autorxs
              </Link>
            </li>
            <li>
              <Link onClick={() => setCloseNavBar(true)} href={'/#tienda'}>
                Nuestra Librería
              </Link>
            </li>
            <li>
              <Link onClick={() => setCloseNavBar(true)} href={'/#distribuidora'}>
                Distribución
              </Link>
            </li>
            <li>
              {' '}
              <Link onClick={() => setCloseNavBar(true)} href={'/#historia'}>
                ¿Quiénes Somos?
              </Link>
            </li>
            <li>
              {' '}
              <Link onClick={() => setCloseNavBar(true)} href={'/#contacto'}>
                Contacto
              </Link>
            </li>
          </ul>
          <img
            className={styles.navbarImage}
            src={'/assets/images/navImage.jpg'}
            alt="Imagen de niña leyendo"
          />
        </div>
      </div>
    </div>
  );
}
